import { render } from "./AuthLayout.vue?vue&type=template&id=5cf6d8e4&ts=true"
import script from "./AuthLayout.vue?vue&type=script&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/uwemudoh/Sites/flywave/qatgifts/qatGiftsBackoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__